export const TILE_WIDTH = 215
export const TILE_HEIGHT = 350
export const TILE_PADDING = 16
